import { Environment } from './env.type';
import { baseEnvironment } from './base';

export const environment: Environment = {
  ...baseEnvironment,
  envName: 'development',
  graphqlUrl: 'https://api.dev.mdopix.com.br/graphql',
  enableDemoMode: false,
};
